import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const container = document.getElementById('root');

// scripts/prerender.js įrašo į build/<maršrutas>/index.html jau PILNAI
// atvaizduotą turinį (ne "app-loading" kraunimosi kevalą). Tokiu atveju
// naudojame hydrateRoot, kad React perimtų esamą DOM be perpiešimo/blyksnio.
// Vietinėje kūrimo aplinkoje (kur build/ nėra prerenderintas) #root turės
// tik "app-loading" elementą — tada darome įprastą createRoot renderį.
const isPrerendered =
  container.firstElementChild && container.firstElementChild.id !== 'app-loading';

if (isPrerendered) {
  ReactDOM.hydrateRoot(container, <React.StrictMode><App /></React.StrictMode>);
} else {
  const root = ReactDOM.createRoot(container);
  root.render(<React.StrictMode><App /></React.StrictMode>);
}
